/**
 * @param {String} eventName The base name of the event to listen for and emit
 * @param {String} ajaxUrl   The URL to get objects from
 */
export default function(eventName, ajaxUrl)
{
    const self = this;

    self.eventName = eventName;
    self.ajaxUrl = ajaxUrl;

    /**
     * Filters with values, in type:values[] pairs
     * @type {Object}
     */
    self.filters = {};

    /**
     * (Extra) arguments for the API call
     * @type {Object}
     */
    self.args = {};

    /**
     * A timeout to prevent excessive Ajax calls
     * @type {Timeout}
     */
    self.filtersTimeout = null;

    /**
     * The duration of the timeout
     * @type {Number}
     */
    self.timeoutDuration = 300;

    /**
     * The total amount of filters
     * @type {Number}
     */
    // self.totalFilters = 0;

    /**
     * The amount of filters that have loaded
     * @type {Number}
     */
    // self.loadedFilters = 0;

    /**
     * Increase the amount of filters
     * @return {void}
     */
    // self.increaseFilterCount = () => {
    //     self.totalFilters++;
    // };

    /**
     * Increase the amount of loaded filters
     * @return {void}
     */
    // self.increaseLoadedFilterCount = () => {
    //     self.loadedFilters++;
    // };

    /**
     * Set filter values by type
     * @param {String} filterType The type/name of the filter
     * @param {Array}  values     The values of the filter
     * @return {void}
     */
    self.setValues = (filterType, values) => {
        self.filters[filterType] = values;
    };

    /**
     * Add an argument for the API call
     * @param {String} key
     * @param {Mixed} value
     * @return {void}
     */
    self.setCallArgument = (key, value) => {
        self.args[key] = value;
    };

    /**
     * Contains timestamps of when calls are requested
     * @type {Array}
     */
    self.callTimestamps = [];

    /**
     * See if a call is the most recent, based on a timestamp
     * This prevents the race condition where a result of an older call comes after a newer one
     * @param {Number} timestamp
     * @return {Boolean}
     */
    self.isMostRecentCall = timestamp => {
        if (! self.callTimestamps.length) {
            return true;
        }

        // Sort the timestamps, latest timestamp at the end
        self.callTimestamps.sort();

        // It is the most recent, if the last timestamp is the same as the given timestamp
        return self.callTimestamps[self.callTimestamps.length - 1] === timestamp;
    };

    /**
     * Listen for updated filters and store the values
     * @return {void}
     */
    self.listenForChangeEvents = () => {
        VueEvents.$on(self.eventName + ':changed', filter => {
            self.setValues(filter.type, filter.values);

            // if (this.loadedFilters > 0 && this.loadedFilters >= this.totalFilters) {
                self.triggerUpdateEvent();
            // }
        });
    };

    /**
     * Handle a change event
     * @return {void}
     */
    self.triggerUpdateEvent = () => {
        // Store the timestamp of this call
        const callTimestamp = (new Date()).getTime();
        self.callTimestamps.push(callTimestamp);

        // Clear the timeout before starting a new one
        clearTimeout(self.filtersTimeout);
        self.filtersTimeout = setTimeout(() => {
            // Store the filter values
            const storeValues = {};
            storeValues[self.eventName] = self.filters;
            MrMovie.session.set(storeValues, 'Search by filters');

            // Define the arguments for the call
            const callArgs = $.extend({}, self.args, self.filters);


            self.doRequest(callArgs);

        }, self.timeoutDuration)
    };

    self.doRequest = (callArgs, emitEvent = true) => {
        // Store the timestamp of this call
        const callTimestamp = (new Date()).getTime();
        self.callTimestamps.push(callTimestamp);

        // Get a list of objects and emit an event when done
        let response =  $.getJSON(self.ajaxUrl, callArgs);


        response.then(response => {
            // Only emit the most recent call, because multiple calls
            if (self.isMostRecentCall(callTimestamp)) {

                if(true === emitEvent) {
                    VueEvents.$emit(self.eventName + ':update', response);
                }


                // Empty the call timestamps stack
                self.callTimestamps = [];
            }
        });

        return response;
    };
}



// WEBPACK FOOTER //
// ./resources/js/MrMovie/SearchByFilters.js